<div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; width: 100%; background-color: #f2f0f0;">
  <mat-card class="login-form">
    <h2 style="text-align: center">Change your password:</h2>
    <mat-form-field class="login-field-wrap">
      <mat-label>Email:</mat-label>
      <input matInput type="email" placeholder="Email" [(ngModel)]="credentials.email" name="email">
    </mat-form-field>
    <mat-form-field class="login-field-wrap">
      <mat-label>New Password:</mat-label>
      <input matInput type="password" placeholder="New Password" [(ngModel)]="credentials.textMessage" name="textMessage">
    </mat-form-field>
    <mat-form-field class="login-field-wrap">
      <mat-label>Confirm Password:</mat-label>
      <input matInput type="password" placeholder="Confirm Password" [(ngModel)]="credentials.textMessage2" name="textMessage2">
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="onSubmit()">SUBMIT</button>
  </mat-card>
</div>
